import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import nlCommon from '../locales/nl/common.json'
// import enCommon from '../locales/en/common.json'
// import deCommon from '../locales/de/common.json'
// import frCommon from '../locales/fr/common.json'
// import esCommon from '../locales/es/common.json'
// import itCommon from '../locales/it/common.json'
// import ptCommon from '../locales/pt/common.json'
// import svCommon from '../locales/sv/common.json'
// import daCommon from '../locales/da/common.json'
// import noCommon from '../locales/no/common.json'
// import fiCommon from '../locales/fi/common.json'

const resources = {
  nl: {
    common: nlCommon,
  },
  // en: {
  //   common: enCommon
  // },
  // de: {
  //   common: deCommon
  // },
  // fr: {
  //   common: frCommon
  // },
  // es: {
  //   common: esCommon
  // },
  // it: {
  //   common: itCommon
  // },
  // pt: {
  //   common: ptCommon
  // },
  // sv: {
  //   common: svCommon
  // },
  // da: {
  //   common: daCommon
  // },
  // no: {
  //   common: noCommon
  // },
  // fi: {
  //   common: fiCommon
  // }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'nl',
    defaultNS: 'common',

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
